// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"be747022","166":"d726af3f","264":"be747022","787":"c3b18a7b"}[chunkId] + ".chunk.js";
};